var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotiicationList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4836 5.8457C12.4836 5.8457 12.9003 6.26237 13.317 7.0957C13.317 7.0957 14.6405 5.01237 15.817 4.5957",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32912 1.68548C6.24706 1.59732 4.63851 1.83717 4.63851 1.83717C3.62281 1.9098 1.6763 2.47923 1.67631 5.80481C1.67633 9.10214 1.65478 13.1671 1.67631 14.7876C1.67631 15.7776 2.28933 18.0871 4.41113 18.2109C6.99016 18.3613 11.6357 18.3933 13.7672 18.2109C14.3377 18.1787 16.2372 17.7308 16.4777 15.6641C16.7267 13.523 16.6772 12.0349 16.6772 11.6807",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 5.84635C18.3334 8.14755 16.466 10.013 14.1626 10.013C11.8593 10.013 9.99194 8.14755 9.99194 5.84635C9.99194 3.54517 11.8593 1.67969 14.1626 1.67969C16.466 1.67969 18.3334 3.54517 18.3334 5.84635Z",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81714 10.8457H9.1505",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81714 14.1797H12.4838",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiicationList);
export default __webpack_public_path__ + "static/media/notiication-list.980fd2d87731c598ca26a9d84ebfb493.svg";
export { ForwardRef as ReactComponent };